var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MultipleOptionsIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Configurator-\\u2014-Beginning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-537.000000, -369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "activity-card-w/multiple-options-copy",
    transform: "translate(527.000000, 212.000000)",
    fill: "#575757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,173 L26,176.5 C26,177.328427 25.3284271,178 24.5,178 L11.5,178 C10.6715729,178 10,177.328427 10,176.5 L10,163.5 C10,162.671573 10.6715729,162 11.5,162 L15,162 L15,158.5 C15,157.671573 15.6715729,157 16.5,157 L29.5,157 C30.3284271,157 31,157.671573 31,158.5 L31,171.5 C31,172.328427 30.3284271,173 29.5,173 L26,173 Z M26,172 L29.5,172 C29.7761424,172 30,171.776142 30,171.5 L30,158.5 C30,158.223858 29.7761424,158 29.5,158 L16.5,158 C16.2238576,158 16,158.223858 16,158.5 L16,162 L24.5,162 C25.3284271,162 26,162.671573 26,163.5 L26,172 Z M11.5,163 C11.2238576,163 11,163.223858 11,163.5 L11,176.5 C11,176.776142 11.2238576,177 11.5,177 L24.5,177 C24.7761424,177 25,176.776142 25,176.5 L25,163.5 C25,163.223858 24.7761424,163 24.5,163 L11.5,163 Z",
    id: "MultipleOptionsIcon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleOptionsIcon);
export default __webpack_public_path__ + "static/media/MultipleOptionsIcon.f37da0e1994a76284b51c9b61a165115.svg";
export { ForwardRef as ReactComponent };